import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface Tag {
  id: string | number;
  name: string;
  color?: string;
}

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'flex shrink-0 items-center' },
})
export class TagComponent {
  @Input({ required: true }) tag!: Tag;
  @Input() compact = false;
  @Input() maxCharacters = 12;
  @Input() icon = 'sell';

  protected get displayName(): string {
    if (this.tag.name.length <= this.maxCharacters) return this.tag.name;
    return `${this.tag.name.slice(0, this.maxCharacters)}…`;
  }
}
